import p from "react";
import { useTranslation as u } from "react-i18next";
import m from "../../../hooks/customization/useCustomization.js";
import b from "./orderButton.module.scss.js";
function g(s) {
  const {
    restaurant: n,
    type: o,
    ...l
  } = s, { t: r } = u(), {
    configuration: t,
    getTextTranslations: a
  } = m(), e = a("popup"), d = o === "now" && n.is_now_available || o === "later" && n.is_schedule_available, c = o === "now" ? (e == null ? void 0 : e.now_btn) || r("shopLanding.selector.nowBtn") : (e == null ? void 0 : e.later_btn) || r("shopLanding.selector.laterBtn");
  return /* @__PURE__ */ p.createElement(
    "button",
    {
      "data-testid": "order-button",
      style: {
        display: d ? "block" : "none",
        backgroundColor: o === "now" ? t == null ? void 0 : t.design.colors.general.primaryButtonBackground : t == null ? void 0 : t.design.colors.general.secondaryButtonBackground,
        color: o === "now" ? t == null ? void 0 : t.design.colors.general.primaryButtonText : t == null ? void 0 : t.design.colors.general.secondaryButtonText
      },
      type: "button",
      className: b.button,
      ...l
    },
    c
  );
}
export {
  g as OrderButton
};
//# sourceMappingURL=OrderButton.js.map
